import { CheckPassword, CheckPasswordRule } from './types';

export const checkPassword: CheckPassword[] = [
  {
    title: '8 or more Characters',
    icon: 'check',
    condition: CheckPasswordRule.length,
  },
];
